import React, { useState } from 'react';
import { getDataUrl } from '../utils/apiConfig';
import './ReportSection.css';
import ReportSectionImgCard from './ReportSectionImgCard';
import VisibilityCaret from './VisibilityCaret';

const ReportSectionGeneral = ({ selectedWorkshop, selectedWorkshopDetails }) => {

  let wsParticipants = selectedWorkshopDetails?.participantStats || {};
  let wsStakeholders = selectedWorkshopDetails?.stakeholderStats || {};  
  //let wsInfo = selectedWorkshopDetails?.generalInfo || {};
  let wsLandUse = selectedWorkshopDetails?.landUseTypes?.map(type => type.name).join(", ") || "No land use types available";
  let wsReports = selectedWorkshopDetails?.reports || {};
  let wsRAV = selectedWorkshopDetails?.reportAutomationVariables || {};
  const base = getDataUrl() + "/";

  let wsName = selectedWorkshop ? selectedWorkshop.name : "";
  
  const [isHidden, setIsHidden] = useState(true);
  const toggleVisibility = () => {
    setIsHidden(!isHidden);
  };
  
  /*
  Available data:
  <li className="is-subtitle is-7">Latitude: {selectedWorkshop ? selectedWorkshop.lat : "/"}</li>
      <li>Longitude: {selectedWorkshop ? selectedWorkshop.lon : "/"}</li>
      <li>Max age: {wsParticipants.max_age ? wsParticipants.max_age : "/"}</li>
      <li>Min age: {wsParticipants.min_age ? wsParticipants.min_age : "/"}</li>
  */

  return (
  <section id="report">    
    <div className="hero is-primary is-bold reportSectionTitle">
      <div id="tagline-red" className="hero-body">
        <div className="container">          
          <div className="columns">
            <div className='column is-two-fifths'>
              <figure className="image">
                <img
                  src={`${base}/${wsRAV.photo_frontpage}`}
                  alt="Imagery from selected workshop."
                />
              </figure>
            </div>            
            <div className="column is-three-fifths">
              <p className="heading">{wsRAV.text_workshop_date ? wsRAV.text_workshop_date : "/"} | {wsRAV.text_workshop_location ? wsRAV.text_workshop_location : "/"}, {wsRAV.text_workshop_country ? wsRAV.text_workshop_country : "/"}</p>
              <h1 className="title">
              Workshop: {selectedWorkshop ? selectedWorkshop.name : "None selected"}
              </h1>
              <h2 className="subtitle">
                <div className="columns">                            
                  <div className="column">
                    <div className="content">
                    <p><span className='has-text-weight-bold'>Organizer: </span>{wsRAV.text_organizing_partners ?wsRAV.text_organizing_partners : "/"}</p>
                    <p><span className='has-text-weight-bold'>Participants: </span>{wsRAV.text_participants_number ?wsRAV.text_participants_number : "/"}</p>                    
                    <p><span className='has-text-weight-bold'>Average age:</span> {wsParticipants.avg_age ? wsParticipants.avg_age.toFixed(1) : "/"}</p>
                    <p><span className='has-text-weight-bold'>Land use: </span>{wsLandUse}</p>                    
                    <p className='has-text-weight-bold'>Stakeholders involved:</p>
                      <ul className="mt-0">
                      {Array.isArray(wsStakeholders) && wsStakeholders.map((item, index) => (
                        <li key={index}>{item.stakeholder_type_name}: {item.count}</li>
                      ))}
                      </ul>
                    </div>
                  </div>                 
                </div>      
              </h2>
            </div>            
          </div>
        </div>
      </div>
    </div>
    <div className='block'>
      <div className="hero is-primary is-bold reportSectionHeader">
        <div id="tagline" className="hero-body">
          <div className="container">
            <div className="columns">            
              <div className="column is-full">
                <h1 className="title">
                  General information
                  <VisibilityCaret onClick={toggleVisibility} isHidden={isHidden} />
                </h1>
                <h2 className="subtitle">
                  It is essential to acknowledge the diversity of participants who contributed to the workshops. Moreover, recognizing the diverse voices and backgrounds of people working on soil health is crucial to ensure meaningful progress in our shared endeavours. Therefore, various sectors were represented in the workshops, including land stewards, researchers, private actors, public actors and citizens. Furthermore, we aimed to ensure demographic diversity, with participants spanning different age groups and genders. The results below reflect on these commitments to inclusivity and equity.
                </h2>
              </div>            
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className={isHidden ? 'is-hidden' : ''}>
      <div className="columns">
        <div className="column is-6">          
          <ReportSectionImgCard
              title="At the workshop"
              imgSource={`${base}/${wsRAV.photo_thank_you_page}`}
              imgAltText="Image taken during the workshop"
              text={'It is essential to acknowledge the diversity of participants who contributed to the workshops. Moreover, recognizing the diverse voices and backgrounds of people working on soil health is crucial to ensure meaningful progress in our shared endeavours.'} />
        </div>
        <div className="column is-6">          
          <ReportSectionImgCard
              title="Stakeholder distribution"
              imgSource={base + wsName + '/demographics/stakeholder_distribution.png'}
              imgAltText="Stakeholder distribution in this workshop in comparison with all workshops"
              text={wsReports.desc_demographics_stakeholders} />
        </div>
      </div>
      <div className="columns">
        <div className="column is-6">
          <ReportSectionImgCard
            title="Gender distribution"
            imgSource={base + wsName + '/demographics/gender_distribution.png'}
            imgAltText="Gender distribution at the workshop"
            text={wsReports.desc_demographics_gender} />
        </div>
        <div className="column is-6">
        <ReportSectionImgCard
            title="Age distribution"
            imgSource={base + wsName + '/demographics/age_distribution.png'}
            imgAltText="Age distribution at the workshop"
            text={wsReports.desc_demographics_age} />
        </div>        
      </div>
    </div>            
  </section>
  );
};

export default ReportSectionGeneral;
